/** @jsx h */
import { h } from 'preact'
import CertificateCard from './CertificateCard'
import ModalConnectionCard from './ConnectionCard'
import FullOrganizationCard from './FullOrganizationCard'
import RecyclingCard from './RecyclingCard'
import FullEvidenceCard from './FullEvidenceCard'
import EvidenceCard from './EvidenceCard'
import FullCertificateCard from './FullCertificateCard'
import AboutCard from './about/AboutCard'

const FullCardContainer = ({ data, journeys, fullCard }) => {
  switch (data.type) {
    case 'OrganizationConnection':
      return <ModalConnectionCard {...data} />

    case 'Claim':
      switch (data.scheme.type) {
        case 'ClaimScheme':
          if (fullCard) {
            return <FullEvidenceCard data={data} />
          } else {
            return <EvidenceCard {...data} />
          }
        case 'CertificationScheme':
        case 'MembershipScheme':
          if (fullCard) {
            return <FullCertificateCard data={data} />
          } else {
            return <CertificateCard {...data} />
          }
        default:
          console.warn('Unrecognised scheme type:', data.scheme.type)
          return null
      }

    case 'Organization':
      return <FullOrganizationCard data={data} journeys={journeys || []} />

    case 'Recycling':
      return <RecyclingCard {...data} />

    case 'Powered':
      return <AboutCard revealed {...data} />

    default:
      console.warn('Unhandled data type:', data.type)
      return null
  }
}

FullCardContainer.defaultProps = {
  fullCard: true
}

export default FullCardContainer
